var map = {
	"./Stroke 1.png": 1040,
	"./Why Our Save the Dat.png": 1041,
	"./all_about_shipping@2x.png": 1042,
	"./ask_for_everything@2x.png": 1043,
	"./big-day@1x.png": 541,
	"./big-day@2x.png": 542,
	"./birds@1x.png": 1044,
	"./birds@2x.png": 1045,
	"./check-list@1x.png": 574,
	"./check-list@2x.png": 575,
	"./circle-better@1x.png": 1046,
	"./circle-better@2x.png": 1047,
	"./empty_rsvp.png": 1048,
	"./empty_rsvp2x.png": 1049,
	"./envelope.png": 576,
	"./envelope.svg": 1050,
	"./envelope@2x.png": 1051,
	"./events_doodle.png": 248,
	"./events_doodle.svg": 1052,
	"./gifts@1x.png": 1053,
	"./gifts@2x.png": 1054,
	"./guest-list@1x.png": 524,
	"./guest-list@2x.png": 525,
	"./guest.png": 1055,
	"./guest.svg": 1056,
	"./guest2x.png": 1057,
	"./guest_approved@2x.png": 1058,
	"./invitations@1x.png": 543,
	"./invitations@2x.png": 544,
	"./invites_paper.svg": 1059,
	"./invites_paper@1x.png": 577,
	"./invites_paper@2x.png": 578,
	"./laptop-one-heart.png": 1060,
	"./laptop-one-heart@2x.png": 1061,
	"./laptop@1x.png": 1062,
	"./laptop@2x.png": 1063,
	"./long-page-checklist.png": 1064,
	"./long-page-checklist@2x.png": 1065,
	"./make_it_personal@2x.png": 1066,
	"./namecard-with-name.png": 1067,
	"./namecard-with-name@2x.png": 1068,
	"./namecard_no_name.svg": 431,
	"./namecard_with_name.svg": 1069,
	"./namecard_with_question_marks.svg": 118,
	"./no_address.png": 1070,
	"./no_address2x.png": 1071,
	"./onboarding_1.png": 432,
	"./onboarding_1@2x.png": 433,
	"./onboarding_2.png": 1072,
	"./onboarding_2@2x.png": 1073,
	"./onboarding_3.png": 434,
	"./onboarding_3@2x.png": 435,
	"./onboarding_4.png": 1074,
	"./onboarding_4@2x.png": 1075,
	"./red-star-left@1x.png": 526,
	"./red-star-left@2x.png": 527,
	"./red-star-right@1x.png": 528,
	"./red-star-right@2x.png": 529,
	"./registry_publish_champagne.svg": 1076,
	"./rsvp@1x.png": 545,
	"./rsvp@2x.png": 546,
	"./save-the-date@1x.png": 547,
	"./save-the-date@2x.png": 548,
	"./sparkle-left.svg": 530,
	"./sparkle-right.svg": 531,
	"./sparkle-up.svg": 579,
	"./ta-da.png": 1077,
	"./ta-da@2x.png": 1078,
	"./talk.svg": 1079,
	"./talk@1x.png": 549,
	"./talk@2x.png": 550,
	"./timeline-line-dark@1x.png": 551,
	"./timeline-line-dark@2x.png": 552,
	"./timeline-line@1x.png": 1080,
	"./timeline-line@2x.png": 1081,
	"./tips.svg": 1082,
	"./underline_long@1x.png": 502,
	"./underline_long@2x.png": 503,
	"./underline_sm@1x.png": 517,
	"./underline_sm@2x.png": 518,
	"./website_publish_confetti.svg": 436,
	"./wedding-websites@1x.png": 580,
	"./wedding-websites@2x.png": 581,
	"./wedding_help.png": 582,
	"./wedding_help.svg": 1083,
	"./wedding_help@2x.png": 1084
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 247;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 247
// module chunks = 49